"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCashReportContainer = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const reserve_1 = require("./reserve");
const getCashReportContainer = ({ bankAccountCashBalances, }) => {
    // Nullable properties are calculated on demand when provided with reserve input
    const cashReportWithoutReserve = {
        totalCash: 0,
        totalEligibleBorrowingBaseAccountCash: 0,
        cashAdvanceRate: 0,
        maxCashAdvanceAmount: 0,
        totalCollectionsAccountCash: 0,
        // Properties dependent on reserve
        totalPreAdvanceCashContribution: null,
        totalCashBorrowingBaseAmount: null,
        effectiveCashAdvanceRate: null,
    };
    // Filter accounts for account types that contribute to borrowing base
    const contributingAccounts = bankAccountCashBalances.filter(({ accountType }) => common_1.typeguards.isBorrowingBaseContributionAccountType(accountType));
    // Capture weights for weighted average advance rate (value: advance rate, weight: account balance)
    const weights = [];
    // Process contributing accounts
    contributingAccounts.forEach((account) => {
        cashReportWithoutReserve.totalCash += account.balance;
        cashReportWithoutReserve.totalEligibleBorrowingBaseAccountCash +=
            account.balance;
        if (account.accountType === finley_types_1.Bank.BorrowerAccountType.Collections) {
            cashReportWithoutReserve.totalCollectionsAccountCash += account.balance;
        }
        cashReportWithoutReserve.maxCashAdvanceAmount +=
            account.balance * (account.cashAdvanceRate ?? 0); // Cash advance rate can be undefined, coerce to 0 when not available
        weights.push({
            value: account.cashAdvanceRate ?? 0,
            weight: account.balance,
        });
    });
    cashReportWithoutReserve.cashAdvanceRate = common_1.utils.calculateWeightedAverage(weights, { roundingPrecision: null });
    return {
        getCashReport: (reserveParams) => {
            if (reserveParams) {
                const { borrowingBaseReserveAmount, fundingConfiguration, } = reserveParams;
                // Calculate dependent properties using borrowing base reserve amount
                const reserveDependentProperties = (0, reserve_1.getReserveDependentProperties)({
                    cashReportWithoutReserve,
                    contributingAccounts,
                    borrowingBaseReserveAmount,
                    fundingConfiguration,
                });
                return {
                    ...cashReportWithoutReserve,
                    ...reserveDependentProperties,
                };
            }
            // If no reserve params available, return the defaults
            return cashReportWithoutReserve;
        },
    };
};
exports.getCashReportContainer = getCashReportContainer;
//# sourceMappingURL=report.js.map